import _defineProperty from "/root/workspace/biel-srm-web_4m4b/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
/**
 * @class DomainDTO
 * @description 域值（枚举值）DTO
 */
class DomainDTO {
  constructor(constVal, title) {
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "const", void 0);
    this.const = constVal;
    this.title = title;
  }
}
export default DomainDTO;